import { atom, getDefaultStore, useAtom } from 'jotai';

const store = getDefaultStore();
const authTokenAtom = atom(findAuthToken());
const accessKeyAtom = atom<string>('');

export const useAuthToken = () => useAtom(authTokenAtom);
export const useAccessKey = () => useAtom(accessKeyAtom);

store.sub(authTokenAtom, () => {
  const value = store.get(authTokenAtom);
  window.localStorage.setItem('auth-token', JSON.stringify(value));
});

export function getAuthToken() {
  const tokens = store.get(authTokenAtom);
  if (!tokens) return null;
  return {
    accessToken: tokens?.accessToken,
    refreshToken: tokens?.refreshToken,
  }
}

export function setAuthToken(token: { accessToken?: string; refreshToken?: string; }) {
  return store.set(authTokenAtom, {
    accessToken: token.accessToken,
    refreshToken: token.refreshToken,
  });
}

export function clearAuthToken() {
  return store.set(authTokenAtom, null);
}

export function useToken() {
  return useAtom(authTokenAtom);
}

function findAuthToken(): any | null {
  return JSON.parse(
    window.localStorage.getItem('auth-token') ?? 'null',
  );
}

